export const initialOtherModalState = {
  sentAmount: '',
  sentCurrency: '',
  sentCommission: '0',
  sentCommissionCurrency: '',
  sentExchangeRate: '0',
  receivedAmount: '',
  receivedCurrency: '',
  receivedCommission: '0',
  receivedCommissionCurrency: '',
  receivedExchangeRate: '0',
  psCommission: '',
  comment: '',
  wallet: '',
  dateTime: '',
  inProgress: false,
  toWallet: '',
  product: '',
  id: '',
  walletId: '',
}
